import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WellProductionService {
  private _wellProdCategories: BehaviorSubject<any> = new BehaviorSubject(null);
  private _wellHistoricalRecords: BehaviorSubject<any> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */

  get wellProdCategories$(): Observable<any> {
    return this._wellProdCategories.asObservable();
  }

  get wellHistoricalRecords$(): Observable<any> {
    return this._wellHistoricalRecords.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  getWellProdCategories(params: any): Observable<any> {
    const url = composeUrl(
      '/v1/WellProductionStatus/GetWellProductionCategories',
      params
    );

    return this._httpClient.get<any>(url);
  }

  downloadWellProdCategories(): Observable<any> {
    return this._httpClient.get(`${environment.apiURL}/${environment.apiVersion}/WellProductionStatus/DownloadOverallProductionCategories`, {
      responseType: 'blob',
    }).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }

  updateWellProdStatus(payload: any): Observable<any> {
    return this._httpClient.put<any>(`${environment.apiURL}/${environment.apiVersion}/WellProductionStatus/UpdateWellProductionCategory`, payload).pipe(
      tap((response: any) => {
        return response
      }),
    );
  }

  // 
  // Historical Records
  // 
  getHistoricalRecords(wellStringId: any): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/WellProductionStatus/GetHistoricalRecords/${wellStringId}`).pipe(
      tap((response: any) => {
        this._wellHistoricalRecords.next(response);
      }),
    );
  }
}
